export const CARD_FIELDS = {
  number: 'number',
  cardholderName: 'cardholderName',
  expirationMonth: 'expirationMonth',
  expirationYear: 'expirationYear',
  email: 'email',
  cvv: 'cvv',
  saveCard: 'saveCard',
  notes: 'notes',
  directDebitDate: 'directDebitDate',
  directDebitEmail: 'directDebitEmail',
  walleyEmail: 'walleyEmail',
  walleyMobileNumber: 'walleyMobileNumber',
}

export const CARD_TYPES = {
  amex: 'american express',
  visa: 'visa',
  masterCard: 'mastercard',
  maestro: 'maestro',
  notDetected: 'notDetected',
  giftCard: 'giftCard',
  omnio: 'omnio',
}
